import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/index/index.vue'
import Home from '@/components/home/home.vue'
import appDownload from '@/components/appDownload/appDownload.vue'
Vue.use(Router)
export default new Router({
   // base: '/',
  // mode:"history",
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
      children:[
        {
          path: '',
          name: 'Index',
          component:() => import('../components/index/index.vue')
        },
        {
          path: '/appDownload',
          name: 'appDownload',
          component: appDownload
          // component:() => import('../components/appDownload/appDownload.vue')
        },
        {
          path: '/newsList',
          name: 'newsList',
          component:() => import('../components/newsList/newsList.vue')
        },
        {
          path: '/newsDetail',
          name: 'newsDetail',
          component:() => import('../components/newsDetail/newsDetail.vue')
        },
        {
          path: '/application',
          name: 'application',
          component:() => import('../components/application/index.vue')
        },
        {
          path: '/applogon',
          name: 'applogon',
          component:() => import('../components/applogon/index.vue')
        },
        {
          path: '/infoList',
          name: 'infoList',
          component:() => import('../components/infoList/infoList.vue')
        },
        {
          path: '/iframe',
          name: 'iframe',
          component:() => import('../components/iframe/iframe.vue')
        },
        {
          path: '/dataCenter',
          name: 'dataCenter',
          component:() => import('../components/dataCenter/dataCenter.vue')
        },
        {
          path: '/Third/:name',
          name: 'Third',
          component:() => import('../components/Third/Third.vue')
        }
      ]
    },
    {
      path: '/login',
      name: 'Login',
      component:() => import('../components/login/login.vue')
    },
    // {
    //   path: '/teacherList',
    //   name: 'teacherList',
    //   component:() => import('../components/teacherList/teacherList.vue')
    // },
    // {
    //   path: '/schoolList',
    //   name: 'schoolList',
    //   component:() => import('../components/schoolList/schoolList.vue')
    // },

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js